{
  "segments": {
    "new": "Nouveau",
    "active": "Actif",
    "vip": "VIP",
    "at_risk": "En danger",
    "churned": "Perdu",
    "wholesale": "Grossiste"
  },
  "loyalty": {
    "bronze": "Bronze",
    "silver": "Argent",
    "gold": "Or",
    "platinum": "Platine"
  },
  "languages": {
    "fr": "Français",
    "wo": "Wolof",
    "en": "Anglais"
  },
  "list": {
    "title": "Clients",
    "all": "Tous",
    "search_placeholder": "Rechercher par nom ou téléphone...",
    "empty": "Aucun client",
    "empty_description": "Aucun client ne correspond aux critères de recherche",
    "col_name": "Nom",
    "col_phone": "Téléphone",
    "col_segment": "Segment",
    "col_total_spent": "Total dépensé",
    "col_last_order": "Dernière commande",
    "col_loyalty": "Fidélité",
    "load_error": "Impossible de charger les clients",
    "load_error_hint": "Veuillez vérifier la connexion et réessayer."
  },
  "customer": {
    "not_found": "Client introuvable",
    "total_orders": "Commandes totales",
    "total_spent": "Total dépensé",
    "last_order": "Dernière commande",
    "member_since": "Client depuis",
    "details": "Informations",
    "preferred_payment": "Paiement préféré",
    "preferred_language": "Langue préférée",
    "addresses": "Adresses",
    "tags": "Étiquettes",
    "notes": "Notes",
    "no_notes": "Aucune note pour ce client",
    "add_note": "Ajouter",
    "add_note_placeholder": "Ajouter une note..."
  },
  "dashboard": {
    "title": "Segments clients",
    "total_customers": "clients au total",
    "clients": "clients",
    "avg_spend": "Dépense moyenne",
    "create_campaign": "Créer une campagne"
  },
  "campaign": {
    "create_title": "Nouvelle campagne",
    "name": "Nom de la campagne",
    "name_placeholder": "Ex : Promo Ramadan Countre Dairy",
    "type": "Canal",
    "types": {
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "email": "Email"
    },
    "target_segment": "Segment cible",
    "estimated_reach": "clients seront atteints",
    "message": "Message",
    "message_placeholder": "Rédigez votre message ici...",
    "characters": "caractères",
    "preview": "Aperçu",
    "schedule": "Date et heure d'envoi",
    "cancel": "Annuler",
    "create": "Créer la campagne",
    "status": {
      "draft": "Brouillon",
      "scheduled": "Planifiée",
      "sending": "En cours d'envoi",
      "completed": "Terminée",
      "cancelled": "Annulée"
    }
  }
}
